import {
  VuexModule,
  Module,
  Mutation,
  getModule,
} from 'vuex-module-decorators';
import store from '@/store';
import { LinkMenu, EditLinkMenuItem } from '@/types/type';

interface ILinkUpdationStore {
  menuItemList: LinkMenu[];
}

@Module({
  dynamic: true,
  store,
  name: 'linkUpdationStore',
  namespaced: true,
})
export default class LinkUpdationStore extends VuexModule
  implements ILinkUpdationStore {
  public menuItemList: LinkMenu[] = [];

  @Mutation
  public setUp(menuItemList: LinkMenu[]): void {
    this.menuItemList = JSON.parse(JSON.stringify(menuItemList));
  }

  @Mutation
  public top(index: number) {
    const tempList: LinkMenu[] = this.menuItemList;
    if (index > 0) {
      const target: LinkMenu = tempList[index];
      tempList.splice(index, 1);
      tempList.unshift(target);
      this.menuItemList = tempList;
    }
  }

  @Mutation
  public up(index: number) {
    const tempList: LinkMenu[] = this.menuItemList;
    if (index > 0) {
      const target: LinkMenu = tempList[index];
      tempList.splice(index, 1);
      tempList.splice(index - 1, 0, target);
      this.menuItemList = tempList;
    }
  }

  @Mutation
  public down(index: number) {
    const tempList: LinkMenu[] = this.menuItemList;
    if (index < tempList.length) {
      const target: LinkMenu = tempList[index];
      tempList.splice(index, 1);
      tempList.splice(index + 1, 0, target);
      this.menuItemList = tempList;
    }
  }

  @Mutation
  public bottom(index: number) {
    const tempList: LinkMenu[] = this.menuItemList;
    if (index < tempList.length) {
      const target: LinkMenu = tempList[index];
      tempList.splice(index, 1);
      tempList.push(target);
      this.menuItemList = tempList;
    }
  }

  @Mutation
  public remove(index: number) {
    const tempList: LinkMenu[] = this.menuItemList;
    if (index < tempList.length) {
      tempList.splice(index, 1);
      this.menuItemList = tempList;
    }
  }

  @Mutation
  public add(menu: EditLinkMenuItem) {
    const merged: LinkMenu = {
      id: menu.id,
      title: menu.title,
      menuType: 'link',
      url: menu.url,
      icon: 'mdi-open-in-new',
    };
    this.menuItemList.push(merged);
  }

  @Mutation
  public update(menu: EditLinkMenuItem) {
    const tempList: LinkMenu[] = this.menuItemList;
    const index = menu.index;
    const origin: LinkMenu = tempList[index];
    const merged: LinkMenu = {
      id: menu.id,
      title: menu.title,
      menuType: origin.menuType,
      url: menu.url,
      icon: origin.icon,
    };
    tempList.splice(index, 1, merged);
    this.menuItemList = tempList;
  }

  public get menuItems(): LinkMenu[] {
    return this.menuItemList;
  }
}

export const linkUpdationModule = getModule(LinkUpdationStore);
